import { useMutation } from "@tanstack/react-query"
import { wealthInstance } from "../fetch"

export const useSaveWealthSurvey=()=>{
    const saveSurvey=async(payload:any)=>{
const {data}= await wealthInstance.post(`/api/IPS/save-survey`, payload)
return data
    }

    const mutation = useMutation({
        mutationFn: saveSurvey,
    })
return mutation
}